export const prefix_lang={
  TH:{
    id:"รหัสที่ใช้บันทึก",
    short_name:"ตัวย่อ",
    detail:"รายละเอียด",
    manage_id:"รหัสกรมการปกครอง",
    alert_id:"กรุณากรอกรหัสที่ใช้บันทึก",
    alert_short_name:"กรุณากรอกตัวย่อ",
    alert_detail:"กรุณากรอกรายละเอียด",
    alert_manage_id:"กรุณากรอกรหัสกรมการปกครอง",
    edit:"แก้ไข",
    delete:"ลบ",
    add_prefix:"เพิ่มข้อมูลคำนำหน้า",
    back_prefix:"กลับไปหน้าแสดงข้อมูลคำนำหน้า",
    save:"บันทึก",
    saved:"ข้อมูถูกบันทึกเรียบร้อยแล้ว",
    deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว",
    delete_place_alert:"คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
    warning_delete:"ข้อมูลลบแล้วไม่สามารถกลับคืนได้",
    want_delete:"ฉันต้องการลบ",
    close_page:"ปิดหน้านี้"
  },
  EN:{
    id:"prefix id",
    short_name:"short name",
    detail:"detail",
    manage_id:"manage id",
    edit:"edit",
    delete:"delete",
    alert_id:"please input prefix id",
    alert_short_name:"please input short name",
    alert_detail:"please input detail",
    alert_manage_id:"please input manage id",
    add_prefix:"add prefix",
    back_prefix:"back to prefix data",
    save:"save",
    saved:"data was saved",
    deleted:"data was deleted",
    delete_place_alert:"Are you sure to delete this data?",
    warning_delete:"deleted data can't reverse",
    want_delete:"delete",
    close_page:"close this page"
  }
}
